import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header";
import Footer4 from "../layout/footer4";
import ScrollToTop from "../element/scrollToTop";
import CountUp from "react-countup";

const bnr3 = require("./../../images/banner/bnr3.webp");
const aboutImg1 = require("../../images/about/1.png");
const aboutImg2 = require("../../images/about/2.png");
const iconTeam = require("../../images/TechnicalTeam.png");
const iconResearch = require("../../images/BestResearch.png");
const iconQuality = require("../../images/BestQulity.png");

const About2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />

      <div className="page-content bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
        {/* --- SIMPLE & CLEAN MINI BANNER --- */}
        <div 
          className="dlab-bnr-inr overlay-black-middle text-center"
          style={{ 
            height: "45vh", 
            minHeight: "350px", 
            backgroundImage: "url(" + bnr3 + ")",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            textAlign: "center"
          }}
        >
          <div className="container" style={{ zIndex: 5, position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <div style={{ animation: "fadeUp 1s ease-out", width: "100%" }}>
              <span style={{ color: "#ff4b2b", fontSize: "14px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "3px", display: "block", marginBottom: "15px" }}>Who We Are</span>
              <h1 style={{ color: "white", fontSize: "3.5rem", fontWeight: "800", marginBottom: "20px", textShadow: "0 4px 15px rgba(0,0,0,0.4)" }}>
                About Our Journey
              </h1>
              <div style={{ width: "60px", height: "4px", background: "#ff4b2b", margin: "0 auto", borderRadius: "2px" }}></div>
            </div>
          </div>
          
          {/* Subtle curved divider */}
          <div style={{ position: "absolute", bottom: "-1px", left: 0, width: "100%", overflow: "hidden", lineHeight: 0 }}>
            <svg viewBox="0 0 1200 120" preserveAspectRatio="none" style={{ position: "relative", display: "block", width: "calc(100% + 1.3px)", height: "40px" }}>
              <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5,73.84-4.36,147.54,16.88,218.2,35.26,69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113,14.29,1200,52.47V0Z" fill="#ffffff" opacity=".25"></path>
              <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" fill="#ffffff" opacity=".5"></path>
              <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.41,78.3,34.2,160.25,37.78,242.09,13.67,61.8-18.2,123.47-52.61,188.91-58.8V0Z" fill="#ffffff"></path>
            </svg>
          </div>
        </div>

        <div className="content-block">
        {/* Global Styles for Animations */}
        <style dangerouslySetInnerHTML={{__html: `
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .hover-feature-card:hover {
            transform: translateY(-10px);
            background: rgba(255, 255, 255, 0.08) !important;
            box-shadow: 0 15px 35px rgba(0,0,0,0.3);
            border-color: rgba(255,255,255,0.1) !important;
          }
          .site-button:hover {
            opacity: 0.9;
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(0,0,0,0.2);
          }
        `}} />
  {/* Our Story Section */}
          <div className="section-full content-inner bg-white" style={{ padding: "100px 0" }}>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-12 m-b30">
                  <div className="our-story" style={{ paddingRight: "40px" }}>
                    <span className="text-primary" style={{ fontWeight: "600", letterSpacing: "2px", textTransform: "uppercase", display: "inline-block", marginBottom: "15px", borderBottom: "2px solid", paddingBottom: "5px" }}>OUR STORY</span>
                    <h2 className="title" style={{ fontSize: "3.2rem", fontWeight: "800", lineHeight: "1.2", marginBottom: "25px", color: "#111" }}>
                      Running a <br />
                      successful business <br />
                      <span className="text-primary">since 2018</span>
                    </h2>
                    <h4 className="title" style={{ fontSize: "1.3rem", fontWeight: "600", color: "#444", lineHeight: "1.6", marginBottom: "20px" }}>
                      All of our items are manufactured in a high-tech
                      production facility by a team of skilled technicians,
                      engineers, and quality controllers.
                    </h4>
                    <p style={{ color: "#666", fontSize: "1.1rem", lineHeight: "1.8" }}>
                      We started manufacturing within a short span of years;
                      Establishment we have supplied more than 150+ sand
                      reclamation plants & machinery & mold handling Equipment
                      as well as Genuine Spares. Castomech Technology has
                      grown into one of the world's most recognized and famous
                      names in foundry equipment in India.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 m-b30">
                  <div style={{ position: "relative", padding: "20px" }}>
                    <div className="bg-primary" style={{ position: "absolute", top: 0, right: 0, bottom: "40px", left: "40px", borderRadius: "15px", opacity: 0.08 }}></div>
                    <img
                      src={aboutImg1}
                      className="radius-sm shadow-lg"
                      style={{ width: "100%", borderRadius: "15px", position: "relative", zIndex: 1, border: "8px solid white" }}
                      alt="Castomech Facility"
                    />
                    {/* Floating badge */}
                    <div className="bg-primary shadow-lg" style={{ position: "absolute", bottom: "30px", left: "-20px", padding: "30px 25px", borderRadius: "10px", zIndex: 2, display: "flex", flexDirection: "column", alignItems: "center", color: "white" }}>
                      <h2 style={{ fontSize: "3rem", fontWeight: "800", color: "white", margin: 0 }}>
                        <CountUp end={8} duration={3} />+
                      </h2>
                      <span style={{ fontSize: "1.1rem", fontWeight: "600" }}>Years Exp.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Core Values Section */}
          <div className="section-full" style={{ backgroundColor: "#111215", padding: "100px 0", color: "white" }}>
            <div className="container">
              <div className="row">
                <div className="col-lg-4 col-md-12 m-b30" style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                  <div className="text-white">
                    <span className="text-primary" style={{ fontWeight: "600", letterSpacing: "2px", textTransform: "uppercase", display: "inline-block", marginBottom: "15px" }}>OUR CORE VALUES</span>
                    <h2 style={{ fontSize: "2.8rem", fontWeight: "800", marginBottom: "20px", color: "white" }}>
                      Thriving and building <br />
                      better products
                    </h2>
                    <p style={{ color: "#AAA", fontSize: "1.1rem", lineHeight: "1.8", marginBottom: "30px" }}>
                      Innovation, quality, and expertise form the foundation of everything we do. We strive to push boundaries and deliver exceptional solutions to the foundry industry globally.
                    </p>
                    <Link to="/contact" className="site-button bg-primary" style={{ padding: "12px 30px", borderRadius: "5px", fontWeight: "600", fontSize: "1rem", color: "white", textDecoration: "none", display: "inline-block", transition: "all 0.3s ease", border: "none" }}>
                      Partners With Us
                    </Link>
                  </div>
                </div>
                <div className="col-lg-8 col-md-12">
                  <div className="row">
                    {/* Feature 1 */}
                    <div className="col-md-6 m-b30">
                      <div style={{ backgroundColor: "rgba(255,255,255,0.03)", padding: "40px", borderRadius: "15px", height: "100%", transition: "transform 0.3s ease, background 0.3s ease", border: "1px solid rgba(255,255,255,0.05)" }} className="hover-feature-card">
                        <div className="bg-primary" style={{ width: "70px", height: "70px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "25px" }}>
                          <img src={iconResearch} alt="Research Icon" style={{ width: "35px", filter: "brightness(0) invert(1)" }} />
                        </div>
                        <h4 className="text-white" style={{ fontWeight: "700", marginBottom: "15px", fontSize: "1.4rem" }}>Best R&D</h4>
                        <p style={{ color: "#999", marginBottom: 0, fontSize: "1.05rem", lineHeight: "1.7" }}>Leading the way in innovation, our Research & Development team is dedicated to advancing product quality ensuring we bring the best solutions.</p>
                      </div>
                    </div>
                    {/* Feature 2 */}
                    <div className="col-md-6 m-b30">
                      <div style={{ backgroundColor: "rgba(255,255,255,0.03)", padding: "40px", borderRadius: "15px", height: "100%", transition: "transform 0.3s ease, background 0.3s ease", border: "1px solid rgba(255,255,255,0.05)" }} className="hover-feature-card">
                        <div className="bg-primary" style={{ width: "70px", height: "70px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "25px" }}>
                          <img src={iconTeam} alt="Team Icon" style={{ width: "35px", filter: "brightness(0) invert(1)" }} />
                        </div>
                        <h4 className="text-white" style={{ fontWeight: "700", marginBottom: "15px", fontSize: "1.4rem" }}>Experienced Team</h4>
                        <p style={{ color: "#999", marginBottom: 0, fontSize: "1.05rem", lineHeight: "1.7" }}>Our highly experienced technical team brings unparalleled expertise, driving innovation and ensuring top-notch solutions.</p>
                      </div>
                    </div>
                    {/* Feature 3 */}
                    <div className="col-md-6 m-b30">
                      <div style={{ backgroundColor: "rgba(255,255,255,0.03)", padding: "40px", borderRadius: "15px", height: "100%", transition: "transform 0.3s ease, background 0.3s ease", border: "1px solid rgba(255,255,255,0.05)" }} className="hover-feature-card">
                        <div className="bg-primary" style={{ width: "70px", height: "70px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "25px" }}>
                          <img src={iconQuality} alt="Quality Icon" style={{ width: "35px", filter: "brightness(0) invert(1)" }} />
                        </div>
                        <h4 className="text-white" style={{ fontWeight: "700", marginBottom: "15px", fontSize: "1.4rem" }}>Best Quality</h4>
                        <p style={{ color: "#999", marginBottom: 0, fontSize: "1.05rem", lineHeight: "1.7" }}>We are committed to delivering the best quality products, crafted with precision and care to meet the highest industry standards.</p>
                      </div>
                    </div>
                    {/* Feature 4 Stats */}
                    <div className="col-md-6 m-b30">
                      <div className="bg-primary shadow-lg" style={{ padding: "40px", borderRadius: "15px", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                        <h2 style={{ fontSize: "4rem", fontWeight: "800", color: "white", marginBottom: "10px" }}>
                          <CountUp end={150} duration={3} />+
                        </h2>
                        <p style={{ color: "rgba(255,255,255,0.9)", fontWeight: "600", fontSize: "1.3rem", marginBottom: 0, letterSpacing: "1px" }}>Global </p>
                        <p style={{ color: "rgba(255,255,255,0.9)", fontWeight: "600", fontSize: "1.3rem", marginBottom: 0, letterSpacing: "1px" }}>Installations</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Stats / Progress Section */}
          <div className="section-full bg-white" style={{ padding: "100px 0" }}>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-12 m-b30 order-lg-2">
                  <div style={{ position: "relative" }}>
                    <div style={{ position: "absolute", top: "-20px", left: "-20px", bottom: "30px", right: "30px", backgroundColor: "#f5f5f5", borderRadius: "15px", zIndex: 0 }}></div>
                     <img
                      src={aboutImg2}
                      className="shadow-lg"
                      style={{ width: "100%", borderRadius: "15px", position: "relative", zIndex: 1 }}
                      alt="Castomech Equipment"
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 m-b30 order-lg-1" style={{ paddingRight: "60px" }}>
                  <div className="section-head mb-5">
                    <span className="text-primary" style={{ fontWeight: "600", letterSpacing: "2px", textTransform: "uppercase", display: "inline-block", marginBottom: "15px" }}>OUR EXPERTISE</span>
                    <h2 className="title" style={{ fontSize: "2.8rem", fontWeight: "800", color: "#111" }}>
                      Unmatched Experience In Sand Reclamation
                    </h2>
                    <p style={{ color: "#666", fontSize: "1.1rem", lineHeight: "1.8", marginTop: "20px" }}>
                      Our technical mastery combined with cutting-edge manufacturing processes enables us to deliver superior systems. Here is a brief look at our proficiency levels.
                    </p>
                  </div>
                  
                  <div className="about-progress-box" style={{ marginBottom: "35px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                      <h6 style={{ fontWeight: "700", fontSize: "1.2rem", margin: 0, color: "#222" }}>Green Sand Reclamation System</h6>
                      <span className="text-primary" style={{ fontWeight: "800", fontSize: "1.2rem" }}><CountUp end={85} duration={3} />%</span>
                    </div>
                    <div className="progress" style={{ height: "12px", borderRadius: "6px", backgroundColor: "#EAEAEA", overflow: "visible" }}>
                      <div
                        className="progress-bar wow slideInLeft bg-primary"
                        style={{ width: "85%", borderRadius: "6px", position: "relative" }}
                        data-wow-delay="0.2s"
                        data-wow-duration="2s"
                      >
                        <div className="border-primary" style={{ position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)", width: "22px", height: "22px", backgroundColor: "white", borderStyle: "solid", borderWidth: "5px", borderRadius: "50%", boxShadow: "0 0 10px rgba(0,0,0,0.15)"}}></div>
                      </div>
                    </div>
                  </div>

                  <div className="about-progress-box">
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                      <h6 style={{ fontWeight: "700", fontSize: "1.2rem", margin: 0, color: "#222" }}>No-Bake Sand Reclamation System</h6>
                      <span className="text-primary" style={{ fontWeight: "800", fontSize: "1.2rem" }}><CountUp end={89} duration={3} />%</span>
                    </div>
                    <div className="progress" style={{ height: "12px", borderRadius: "6px", backgroundColor: "#EAEAEA", overflow: "visible" }}>
                      <div
                        className="progress-bar wow slideInLeft bg-primary"
                        style={{ width: "89%", borderRadius: "6px", position: "relative" }}
                        data-wow-delay="0.4s"
                        data-wow-duration="2s"
                      >
                         <div className="border-primary" style={{ position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)", width: "22px", height: "22px", backgroundColor: "white", borderStyle: "solid", borderWidth: "5px", borderRadius: "50%", boxShadow: "0 0 10px rgba(0,0,0,0.15)"}}></div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Global Styles for Hover Effects and Animations */}
        <style dangerouslySetInnerHTML={{__html: `
          @keyframes floatBlob {
            0% { transform: scale(1) translate(0px, 0px); }
            100% { transform: scale(1.2) translate(30px, -20px); }
          }
          @keyframes floatCard {
            0%, 100% { transform: translateY(0) rotate(0deg); }
            50% { transform: translateY(-20px) rotate(2deg); }
          }
          @keyframes fadeInLeft {
            from { opacity: 0; transform: translateX(-50px); }
            to { opacity: 1; transform: translateX(0); }
          }
          .play-btn-hover:hover {
            background: rgba(255,255,255,0.2) !important;
            transform: scale(1.1);
            border-color: #ff4b2b !important;
          }
          .hover-feature-card:hover {
            transform: translateY(-10px);
            background: rgba(255, 255, 255, 0.08) !important;
            box-shadow: 0 15px 35px rgba(0,0,0,0.3);
            border-color: rgba(255,255,255,0.1) !important;
          }
          .site-button:hover {
            opacity: 0.9;
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(0,0,0,0.2);
          }
        `}} />
      </div>

      <Footer4 />
      <ScrollToTop className="icon-up" />
    </>
  );
};

export default About2;
